/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationFilterRequest
 */
export interface ApplicationFilterRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationFilterRequest
     */
    applicationIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFilterRequest
     */
    includeGlobalValues?: boolean;
}

/**
 * Check if a given object implements the ApplicationFilterRequest interface.
 */
export function instanceOfApplicationFilterRequest(value: object): value is ApplicationFilterRequest {
    return true;
}

export function ApplicationFilterRequestFromJSON(json: any): ApplicationFilterRequest {
    return ApplicationFilterRequestFromJSONTyped(json, false);
}

export function ApplicationFilterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFilterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationIds': json['applicationIds'] === undefined ? undefined : json['applicationIds'] === null ? null : json['applicationIds'],
        'includeGlobalValues': json['includeGlobalValues'] == null ? undefined : json['includeGlobalValues'],
    };
}

export function ApplicationFilterRequestToJSON(json: any): ApplicationFilterRequest {
    return ApplicationFilterRequestToJSONTyped(json, false);
}

export function ApplicationFilterRequestToJSONTyped(value?: ApplicationFilterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationIds': value['applicationIds'],
        'includeGlobalValues': value['includeGlobalValues'],
    };
}

